import type { MissionConfig } from './types';

// Path-engine's /api/sessions/{id}/sendToDrone route takes the session
// id in the URL and reads the cached ApiPlanResult +
// ResolvedApiRoutePlanConfig server-side — no request body required.
// See board/2026-04-15_path-engine_sendtodrone-contract-answers.md.
export const SEND_TO_DRONE_PATH_PREFIX = '/api/sessions';

export const SEND_TO_DRONE_PATH_SUFFIX = '/sendToDrone';

export const SIMULATION_FAILED_MESSAGE = 'Failed to run vk-sim mission simulation';

// Defaults mirror vk-sim-bridge.py argparse defaults so the POC behaves
// identically between the Python scout script and the web UI.
export const DEFAULT_MISSION_CONFIG: MissionConfig = {
    speedMps: 5.0,
    swathWidthM: 5.0,
    takeoffAltitudeM: 10.0,
    tankCapacityL: 16.0
};

// Epoch used as the `recordedAt` base for synthetic telemetry points
// derived from vk-sim trace samples. The absolute timestamp is
// meaningless downstream (the rate-bucket pipeline consumes deltas, not
// wall-clock), so we use a fixed epoch and let `tMs` from the trace
// drive monotonic ordering.
export const SYNTHETIC_TRACE_EPOCH_MS = 0;
